import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import * as TC from '../styles/TableCell_Styles';

class CustomTableCell extends Component {

    // --- HELPERS ---

    enhancedCell = () => {

        const { classes, data, column } = this.props;

        let formatted;


        if(data[column]) {


            if (column === 'release' && data[column].sort !== 0) {

                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        {data[column].list.map((x) => {
                            return (
                                <div key={x}>
                                    <Chip 
                                        style={TC.getReleaseStyle(x, data[column].current)} 
                                        label={x}
                                        />
                                </div>
                            )
                        })}
                    </TableCell>
                )
    
            } else if (column === 'severity' && data[column].sort !== 0) {
    
                const label = data[column].string;
    
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        <Chip 
                            style={TC.getSevStyle(label)} 
                            label={label}
                        />
                    </TableCell>
                )
    
            } else if (column === 'assignment' && data[column].sort !== 0) {
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
    
                        {Object.keys(data[column].store).map((x) => {
                            return (
                                <div key={x}>
                                    <Chip 
                                        style={TC.getAssignmentStyle(x)} 
                                        label={x}
                                        />
                                </div>
                            )
                        })}
                    </TableCell>
                )
    
            } else if (column === 'status'){
    
                const statusSort = data[column].sort;
    
    
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        {TC.getStatusIcon(statusSort)}
                    </TableCell>
                )
    
            } else if (column === 'number') {
                
                const link = data.url.string;
                const linkToDefect= (event) => {
                    window.open(event.currentTarget.getAttribute('defectlink'));
                }
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        <Button defectlink={link} onClick={linkToDefect} style={TC.getLinkButtonStyle(data.status.sort)}>
                            {data[column].string}
                        </Button>
    
                    </TableCell>
                )
            } else if (column === 'created' || column === 'updated'){
    
    
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        <Chip 
                            style={TC.updatedStyle}
                            className={classes.updated}
                            classes={{
                                label: classes.label
                            }}
                            label={data[column].string}
                        >
                        </Chip>
                    </TableCell>
                )
    
            } else if(column === 'title' || column === 'summary'){
    
                formatted = (
                    <TableCell style={TC.getColumnStyle(column)}>
                        {data[column].string}
                    </TableCell>
                )
    
            } else {
                // let blank = data[column].string;
                let blank = 'o'
                formatted = (
                    <TableCell style={TC.getEmptyStyle()}>
                        {blank}
                    </TableCell>
                )
    
            }







        } else {
            formatted = null;
        }

        return formatted
    }

    // --- RENDER ---

    render() {
        return this.enhancedCell(this.props)
    }
}
const style = {
    updated: {
        background: '#F8F9F9'
    },
    label: {
        whiteSpace: 'pre'
    }
}

CustomTableCell.propTypes = {
    column: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
};

export default withStyles(style)(CustomTableCell);


// WEBPACK FOOTER //
// ./src/js/components/Table_Cell.js